angular.module('rjmNg.api').factory 'DashboardTimeOptions', [
  "$q"
  "$resource"
  "$timeout"
  "serviceUrl"
  (
    $q
    $resource
    $timeout
    serviceUrl
  ) ->
    cache = {}
    ttlPromises = {}

    # sets a cache key/value pair
    # clears it from the cache after the ttl elapses (or 5 minutes by default),
    # if the value is reset at some point between the time its set and when it was about to expire
    # the ttl is extended for another ttl milliseconds
    setCacheWithTTL = (key, value, ttl = 300000) ->
      cache[key] = value

      if ttlPromises[key]?
        $timeout.cancel ttlPromises[key]

      ttlPromises[key] = $timeout () ->
        delete cache[key]
      , ttl

    (dashboardId) ->

      baseUrl = serviceUrl("/dashboards/#{dashboardId}/time-options")

      defaultParams =
        withCredentials: true
        headers:
          Accept: 'application/json'
          'Content-Type': 'application/json'

      actions =
        set: angular.extend {}, defaultParams,
          method: 'PUT'
        delete: angular.extend {}, defaultParams,
          method: 'DELETE'
        get: angular.extend {}, defaultParams,
          method: 'GET'

      resource = $resource(baseUrl, {}, actions)

      set: (timerange, interval = null) ->
        payload =
          timerange: timerange
          interval: interval
          active: true

        promise = resource.set({}, payload).$promise

        promise.then (response) ->
          setCacheWithTTL(dashboardId, {timerange, interval})
        .catch (error) ->

        promise

      get: (force = false) ->
        deferred = $q.defer()

        if not force and cache[dashboardId]?
          deferred.resolve cache[dashboardId]
        else
          promise = resource.get().$promise
          promise.then (response) ->
            setCacheWithTTL(dashboardId, response)
            deferred.resolve response
          .catch (error) ->
            deferred.reject error

        deferred.promise

      delete: () ->
        promise = resource.delete().$promise
        promise.then () ->
          setCacheWithTTL(dashboardId, {})
        promise
]
